import {
  Component,
  OnDestroy,
} from "@angular/core";

import { CommonModule } from "@angular/common";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: "app-group",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    HoverMenuDirective,
    MatIcon,
    MatIconModule,
    MatMenuModule,
    MatMenuTrigger,
    MatButtonModule

  ],
  templateUrl: "./group.component.html",
  providers: [],
})
export class GroupComponent implements OnDestroy{
[x: string]: any;

  ngOnDestroy(): void {
  }
}